// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading-spinner {
  width: 60px;
  height: 60px;
  border: 6px solid rgba(255, 255, 255, 0.15);
  border-top: 6px solid var(--primary-color, #004A9A);
  border-radius: 50%;
  animation: spin 1s linear infinite, pulse 1.8s ease-in-out infinite;
  box-shadow: 0 0 12px rgba(0, 82, 204, 0.5);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 10px rgba(0, 82, 204, 0.3);
  }
  50% {
    box-shadow: 0 0 20px rgba(0, 82, 204, 0.8);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Loading/Loading.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,mDAAA;EACA,kBAAA;EACA,mEAAA;EACA,0CAAA;AADF;;AAIA;EACE;IACE,yBAAA;EADF;AACF;AAIA;EACE;IACE,0CAAA;EAFF;EAIA;IACE,0CAAA;EAFF;AACF","sourcesContent":[".loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  // background: rgba(0, 0, 0, 0.3);\n  // backdrop-filter: blur(2px);\n}\n\n.loading-spinner {\n  width: 60px;\n  height: 60px;\n  border: 6px solid rgba(255, 255, 255, 0.15);\n  border-top: 6px solid var(--primary-color, #004A9A);\n  border-radius: 50%;\n  animation: spin 1s linear infinite, pulse 1.8s ease-in-out infinite;\n  box-shadow: 0 0 12px rgba(0, 82, 204, 0.5);\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    box-shadow: 0 0 10px rgba(0, 82, 204, 0.3);\n  }\n  50% {\n    box-shadow: 0 0 20px rgba(0, 82, 204, 0.8);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
